




import { Component, Vue, Watch } from "vue-property-decorator";

import {
  CatalogEntityKind,
  openCatalogEntityModal,
  parseCatalogEntityId
} from "./utils/openCatalogEntity";

@Component
export default class ProductCatalogEntityProxy extends Vue {
  modal: any = null;
  closingSilently = false;

  get entityKind(): CatalogEntityKind {
    return this.$route.meta.catalogEntity as CatalogEntityKind;
  }

  mounted() {
    this.onParamsChange();
  }

  @Watch("$route.params")
  onParamsChange() {
    this.closeModalSilently();

    const id = parseCatalogEntityId(this.$route.params.id, this.entityKind);
    if (id == null) {
      return;
    }

    this.modal = openCatalogEntityModal(this, this.entityKind, id, {
      parent: this,
      onClose: () => this.handleModalClosed()
    });
  }

  closeModalSilently() {
    if (!this.modal) {
      return;
    }
    this.closingSilently = true;
    this.modal.close();
    this.modal = null;
  }

  goToCatalog() {
    if (this.$route.name === "product-catalog") {
      return;
    }
    this.$router.push({ name: "product-catalog" });
  }

  handleModalClosed() {
    if (this.closingSilently) {
      this.closingSilently = false;
      return;
    }
    this.modal = null;
    this.goToCatalog();
  }

  close() {
    this.closeModalSilently();
    this.goToCatalog();
  }

  beforeDestroy() {
    this.closeModalSilently();
  }
}
